import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Button } from "../components/ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQS } from "../data/content";

export default function FaqsPage() {
  return (
    <main data-testid="faqs-page" className="bg-slate-950 text-slate-100 min-h-screen">
      <PageHeader
        eyebrow="/ FAQs"
        title={
          <>
            Frequently asked
            <br />
            <span className="text-slate-500">questions.</span>
          </>
        }
        subtitle="The most common questions from facility heads, IT leads and procurement teams evaluating GenX. Can't find your answer? Reach our team via the contact page."
      />

      <section className="py-20 md:py-28 px-6 md:px-10 border-b border-white/5">
        <div className="max-w-5xl mx-auto">
          <Accordion type="single" collapsible data-testid="faq-accordion" className="border-t border-white/5">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/5"
              >
                <AccordionTrigger className="text-left py-7 text-base md:text-lg font-medium text-slate-100 hover:text-cyan-300 hover:no-underline group">
                  <span className="flex items-baseline gap-5">
                    <span className="text-[11px] font-mono text-cyan-400/60 group-hover:text-cyan-400 mt-1">
                      Q.0{i + 1}
                    </span>
                    <span className="flex-1">{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 leading-relaxed pb-7 pl-12 md:pl-16 text-sm md:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <section className="py-20 md:py-24 px-6 md:px-10">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-6 border border-white/10 p-8 md:p-10 bg-slate-900">
          <div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-cyan-400 font-mono mb-2">
              / Didn't find it?
            </div>
            <h3 className="text-2xl tracking-tight font-medium text-slate-100">
              Our solutions team is one email away.
            </h3>
          </div>
          <Link to="/contact">
            <Button className="bg-cyan-400 text-slate-950 hover:bg-cyan-300 rounded-none font-semibold h-12 px-7 btn-glow group">
              Ask a Question
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
        </div>
      </section>
    </main>
  );
}
